import { computed } from "vue";
import getCurrentEnvironmentByHostname from "@/helpers/shared/getCurrentEnvironmentByHostname";
import { useTimedClickActivation } from "@/composables/useTimedClickActivation";

const INTERACTIVE_SELECTORS = "button, a, input, select, textarea";

export function useDevtoolDialogActivation() {
  const isDevtoolAvailable = computed(
    () => getCurrentEnvironmentByHostname() !== "production",
  );

  const {
    isActivated: showDevtoolDialog,
    registerClick,
    resetActivation: closeDevtoolDialog,
  } = useTimedClickActivation();

  const handleDevtoolActivationClick = (event: MouseEvent) => {
    if (!isDevtoolAvailable.value) {
      return;
    }

    if ((event.target as Element).closest(INTERACTIVE_SELECTORS)) {
      return;
    }

    registerClick();
  };

  return {
    isDevtoolAvailable,
    showDevtoolDialog,
    closeDevtoolDialog,
    handleDevtoolActivationClick,
  };
}
